import React from 'react';
import { NavLink } from 'react-router-dom';
// import MapContainer from '../MapContainer/MapContainer';
import ReactTooltip from 'react-tooltip';
import './Footer.scss';

import logo from '../../assets/img/site/Celuba-logo-blanco.gif';

import { BsFacebook, BsInstagram, BsMailbox } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">

            <div className="col-md-4 my-5 text-center text-center">
              <Link to="/">
                <img
                  className="footer__logo"
                  src={logo}
                  alt="celuba - Darregueira, Argentina."
                />
              </Link>
            </div>

            <div className="col-md-4 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center text-md-left">
              <h3 className="footer__title">Contacto</h3>
              <address>
                <div>
                  <p>📍 Peatonal Drago 72<br />📲 2916435709</p>
                  <p>📍 Chiclana 130<br />📲 2914629352</p>
                </div>
                Bahía Blanca, Argentina <br />
                <a className="mt-1" href="mailto:celuba@gmail.com?Subject=Consulta%20desde%20celuba.com.ar&body=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20">celuba@gmail.com</a>
              </address>
              <NavLink activeClassName="active" to="/terminos-condiciones" className="footer__link-terms">
                Términos y Condiciones
              </NavLink>
              <NavLink activeClassName="active" to="/certificado-de-garantia" className="footer__link-terms">
                Certificado de garantia
              </NavLink>
            </div>

            <div className="col-md-2 mt-2 mb-1 mt-sm-5 mb-sm-3 text-center text-md-left">
              <h3 className="footer__title">Seguinos:</h3>
              <p>
                {/* <a className="footer__icon mt-2" target="_blank" href="https://www.facebook.com/misuenohogardarregueira?locale=es_LA/" alt="Seguinos en Facebook">
                  <BsFacebook /> <small>/ celuba</small>
                </a> */}
                <a className="footer__icon mt-2" target="_blank" href="https://www.instagram.com/celuba_bahiablanca/?hl=es" alt="Seguinos en Instagram">
                  <BsInstagram /> <small>celuba_bahiablanca</small>
                </a>
              </p>
            </div>

          </div>
        </div>

        <div className="footer__copy">
          <div className="container">
            <div className="row">
              <div className="col-md-8 text-center text-md-left">
                Celuba ©{new Date().getFullYear()} | Todos los derechos reservados.
              </div>
              <div className="col-md-4 text-center text-md-right">
                Desarrollado por: <a href="https://www.paradigma.com.ar/">Paradigma del Sur S.A. <img src="https://paradigma.com.ar/img/favicon.ico" height="16" /></a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* <a
        data-for="sucursal"
        data-tip="Consúltanos"
        data-iscapture="true"
        title="Email"
        href="mailto:celuba@gmail.com?Subject=Consulta%20desde%20celuba.com.ar&body=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"
        className="float float_2" target="_blank">
        <i className="fa fa-envelope-o my-float"></i>
      </a>
      <ReactTooltip
        id="sucursal"
        place="top"
        type="warning"
        effect="float"
        multiline={false}
      /> */}
    </>
  );
};

export default Footer;
